// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SHOW_FULL_ANSWER = "Zobraz cel\u00fa odpove\u010f";
